module.exports = __webpack_public_path__ + "asset/image-Property-1-Shield-b4e13f132fbcf5a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Property-1-Shield.svg
// module id = lhZF
// module chunks = 0